var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88 0C1.28942 0 0 1.28942 0 2.88V21.12C0 22.7106 1.28942 24 2.88 24H21.12C22.7106 24 24 22.7106 24 21.12V2.88C24 1.28942 22.7106 0 21.12 0H2.88ZM8.8236 16.5216C8.9644 16.6184 9.1976 16.6668 9.5232 16.6668C9.8488 16.6668 10.082 16.6184 10.2228 16.5216C10.3636 16.4248 10.4516 16.3016 10.4868 16.152C10.522 15.9936 10.5396 15.8308 10.5396 15.6636V13.9344H12.2292C12.5988 13.9344 12.9728 13.8684 13.3512 13.7364C13.7296 13.5956 14.0772 13.3932 14.394 13.1292C14.7196 12.8564 14.9792 12.5176 15.1728 12.1128C15.3752 11.708 15.4764 11.2372 15.4764 10.7004C15.4764 10.1548 15.3752 9.6796 15.1728 9.2748C14.9792 8.87 14.7196 8.5312 14.394 8.2584C14.0772 7.9768 13.7296 7.77 13.3512 7.638C12.9816 7.506 12.612 7.44 12.2424 7.44H9.5364C9.2108 7.44 8.9776 7.4884 8.8368 7.5852C8.696 7.682 8.608 7.8096 8.5728 7.968C8.5376 8.1176 8.52 8.276 8.52 8.4432V15.6504C8.52 15.8176 8.5376 15.9804 8.5728 16.1388C8.608 16.2972 8.6916 16.4248 8.8236 16.5216ZM12.2424 11.928H10.5396V9.4464H12.2292C12.4756 9.4464 12.6912 9.4992 12.876 9.6048C13.0696 9.7104 13.2192 9.8556 13.3248 10.0404C13.4304 10.2252 13.4832 10.4408 13.4832 10.6872C13.4832 10.9776 13.4172 11.2152 13.2852 11.4C13.162 11.5848 13.0036 11.7212 12.81 11.8092C12.6252 11.8884 12.436 11.928 12.2424 11.928Z",
    fill: "#FFB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/p.8c6eeb44805066eb79f5155270a2a73f.svg";
export { ForwardRef as ReactComponent };